import axios from '../../axios';

export default {
  namespaced: true,
  state: {
    apiEndpoint: 'https://api.checkout.com/tokens',
    apiKey: 'pk_n3stcqemv5fchs473iet2ng3pq6',
    cardDetails: {},
  },
  getters: {
    getCardDetails: (state) => {
      state.cardDetails;
    },
  },
  mutations: {
    setCardDetails: (state, payload) => {
      state.cardDetails = payload;
    },
  },
  actions: {
    async GetCardDetailsToken({ state }, cardDetails) {
      const tokenRequestEndpoint = `${state.apiEndpoint}`;
      const config = {
        headers: { Authorization: `Bearer ${state.apiKey}` } };
      try {
        const res = await axios.post(tokenRequestEndpoint, cardDetails, config);
        // console.log(res);
        // commit('setCardDetails', res.data);
        return res.data;
      }
      catch (error) {
        console.log('error:', error);
      }
    },
  },
};
